export const vehicleConditionList = ["NEW", "SECOND"];
export const companyList = ["AMARTA", "CHERY", "NETA", "VINVAST"];
export const vehicleCategoryList = ["motorcycle", "car"];

export const allowedOrganization = [
  {
    companyCode: "AMARTAHONDA",
    companyId: "AMARTA",
    amartaVipCode: "AMARTAHONDA",
    otodisCode: "AMARTA",
    offerCode: "AMARTA",
    copanCode: "AMARTA",
    copanAreaCode: "JABAR2",
    copanDefaultBrand: "HONDA",
    copanDefaultBrandUuid: "afce6884-fc4d-4f7a-b784-09d2a2f7b903",
  },
  {
    companyCode: "AMARTACHERY",
    companyId: "CHERY",
    amartaVipCode: "CHERY",
    otodisCode: "CHERY",
    offerCode: "CHERY",
    copanCode: "CHERY",
    copanAreaCode: "JAWABARAT",
    copanDefaultBrand: "CHERY",
    copanDefaultBrandUuid: "7835d023-762f-499a-84a5-539cb44f3580",
  },
  {
    companyCode: "AMARTANETA",
    companyId: "NETA",
    amartaVipCode: "NETA",
    otodisCode: "NETA",
    offerCode: "NETA",
    copanCode: "NETA",
    copanAreaCode: "JAWABARAT",
    copanDefaultBrand: "NETA",
    copanDefaultBrandUuid: "2638cb27-e0cf-426b-a66f-a49073219972",
  },
  {
    companyCode: "AMARTAVINFAST",
    companyId: "VINFAST",
    amartaVipCode: "VINFAST",
    otodisCode: "VINFAST",
    offerCode: "VINFAST",
    copanCode: "VINFAST",
    copanAreaCode: "JAWABARAT",
    copanDefaultBrand: "VINFAST",
    copanDefaultBrandUuid: "fc96dd9d-6b5c-443a-bf3c-a6ec7df119e5",
  },
  {
    companyCode: "TRIMOBI",
    companyId: "TRIMOBI",
    amartaVipCode: "TRIMOBI",
    otodisCode: "TRIMOBI",
    offerCode: "TRIMOBI",
    copanCode: "TRIMOBI",
    copanAreaCode: "DEFAULT",
    copanDefaultBrand: "HONDA",
    copanDefaultBrandUuid: "afce6884-fc4d-4f7a-b784-09d2a2f7b903",
  },
];

export const option_notice_type = ["JABAR", "JAKARTA", "MANADO", "GORONTALO"];
